import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Bookmark16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.05001 0.75H12.95C13.6545 0.75 14.25 1.33445 14.25 2.04153C14.25 6.01436 14.3636 10.0058 14.2497 13.9768C14.2236 14.8924 13.5 15.5 12.3277 15.0675L8.02201 12.5344L3.71845 15.0662C2.5 15.5 1.7462 14.947 1.75001 13.9535V2.04153C1.75001 1.33445 2.34557 0.75 3.05001 0.75ZM3.25001 2.25V13.6015L7.35047 11.1891C7.7559 10.9433 8.28811 10.9433 8.69353 11.1891L12.75 13.5756V2.25H3.25001Z'
      fill='currentColor'
    />
  </Svg>
);

Bookmark16.displayName = 'Bookmark16';
export default Bookmark16;
